export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_RESPONSE = 'SET_RESPONSE'
export const SET_PAGE = 'SET_PAGE'
